import {filterCountries, getDefaultCountry} from '@/utils/utils';
import {Autocomplete, Stack, Typography, styled, IconButton} from '@mui/material';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import AppTextField from './AppTextField';
import {KeyboardArrowDown} from "@mui/icons-material";
import axiosInstance from '@/utils/axios';
import API from '@/constant/API';

// ----------------------------------------------------------------------

const StyledAppTextField = styled(AppTextField)(({theme}) => ({
  '.MuiOutlinedInput-root': {
    paddingRight: '8px!important'
  },
  '.MuiInputAdornment-positionEnd': {
    position: 'absolute',
    margin: '0 !important',
    right: '16px',
  }
}));

export default function NationCodeAutoComplete({
                                                 onChange,
                                                 value,
                                                 customOptions,
                                                 label,
                                                 disabled,
                                                 showAvailable = true,
                                                 iconBorderRadius = '50%',
                                                 fullWidth,
                                                 includeUSD = false
                                               }) {
  const {t} = useTranslation();

  const {countries, locationInfo} = useSelector((state) => state.app);
  const {isAuthenticated} = useSelector((state) => state.user);

  const [kycNation, setKycNation] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (isAuthenticated && countries?.length) {
      _fetchKyc();
    }
  }, [isAuthenticated, countries]);

  useEffect(() => {
    if (value) {
      setSelected(value);
    }
  }, [value]);

  const _fetchKyc = async () => {
    const kycInfo = await axiosInstance.post(API.KYC_INFO);
    if (kycInfo?.nation) {
      setKycNation(kycInfo.nation);
    } else {
      _checkDefaultSelection();
    }
  };

  useEffect(() => {
    if (kycNation) {
      _checkDefaultSelection();
    }
  }, [kycNation]);

  const _checkDefaultSelection = () => {
    const country = getDefaultCountry(countries, kycNation ?? locationInfo?.countryIsoCode);
    if (country) _onChange(null, country);
  }

  const _filterOptions = (_, {inputValue}) => {
    if (!countries.length) return [];
    inputValue = inputValue?.trim() || '';
    const res = filterCountries(countries, inputValue);
    return res
  }

  const _onChange = (evt, record) => {
    setSelected(record);
    if (onChange) onChange(record);
  }

  return <Autocomplete
    fullWidth={fullWidth}
    sx={{width: fullWidth ? '100%' : 120}}
    options={countries}
    value={selected}
    disabled={disabled}
    getOptionLabel={(option) => option.areaCode || ''}
    noOptionsText={t('no_options')}
    filterOptions={_filterOptions}
    onChange={_onChange}
    getOptionKey={(option) => option.id}
    renderOption={(props, option) => (
      <Stack key={option.id} direction={'row'} component="li" {...props}>
        {/* <Avatar alt={option.code}>
          <img src={getNationIcon(option)} />
        </Avatar> */}
        <Stack alignItems={'flex-start'}>
          <Typography>{option.areaCode}</Typography>
          {showAvailable && option.available &&
            <Typography variant='caption' color={'text.secondary'}>{option.available || 0}</Typography>}
        </Stack>
        <Typography className="pl-[12px] color-text-secondary">{option.code3?.toUpperCase()}</Typography>
      </Stack>
    )}
    renderInput={(params) => (
      <StyledAppTextField
        {...params}
        endAdornment={
          <IconButton edge="end" sx={{padding: 0}}>
            <KeyboardArrowDown/>
          </IconButton>
        }
      />
    )}
  />
}
